import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchDashboard,
  fetchNotifications,
  markNotificationAsRead,
} from "../adminApi";
import { MarkAsRead } from "../models";

export const fetchDashboardThunk = createAsyncThunk(
  "fetchDashboard",
  async (year: number) => {
    let response: any;
    await fetchDashboard(year)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response?.data;
      });
    return response;
  }
);

export const markNotificationAsReadThunk = createAsyncThunk(
  "markNotificationAsRead",
  async (payload: MarkAsRead) => {
    let response: any;
    await markNotificationAsRead(payload)
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);

export const fetchNotificationsThunk = createAsyncThunk(
  "fetchNotifications",
  async () => {
    let response: any;
    await fetchNotifications()
      .then((data) => {
        response = data;
      })
      .catch((error) => {
        response = error.response.data;
      });
    return response;
  }
);